export var EyeDropperKeyboardEventKey;
(function (EyeDropperKeyboardEventKey) {
    EyeDropperKeyboardEventKey["esc"] = "Escape";
    EyeDropperKeyboardEventKey["enter"] = "Enter";
    EyeDropperKeyboardEventKey["space"] = " ";
    EyeDropperKeyboardEventKey["switch"] = "Shift";
    EyeDropperKeyboardEventKey["copy"] = "c";
})(EyeDropperKeyboardEventKey || (EyeDropperKeyboardEventKey = {}));
export var PaletteCursorTarget;
(function (PaletteCursorTarget) {
    PaletteCursorTarget["colormap"] = "colormap";
    PaletteCursorTarget["hue"] = "hue";
    PaletteCursorTarget["alpha"] = "alpha";
})(PaletteCursorTarget || (PaletteCursorTarget = {}));
